import './index.css.proxy.js';
/* src/routes/projects/index.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	query_selector_all,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../web_modules/svelte/internal.js";

import Btn from "../../../_components/Btn.js";
import Hero from "../../../_components/Hero.js";
import Content from "../../../_components/Content.js";

function create_default_slot_1(ctx) {
	let t;

	return {
		c() {
			t = text("Contact me!");
		},
		l(nodes) {
			t = claim_text(nodes, "Contact me!");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (11:0) <Content>
function create_default_slot(ctx) {
	let div11;
	let div0;
	let h3;
	let t0;
	let t1;
	let p0;
	let t2;
	let t3;
	let div3;
	let a0;
	let div1;
	let t4;
	let t5;
	let a1;
	let div2;
	let t6;
	let t7;
	let p1;
	let t8;
	let t9;
	let div6;
	let a2;
	let div4;
	let t10;
	let t11;
	let a3;
	let div5;
	let t12;
	let t13;
	let div9;
	let a4;
	let div7;
	let t14;
	let t15;
	let a5;
	let div8;
	let t16;
	let t17;
	let div10;
	let p2;
	let t18;
	let t19;
	let a6;
	let btn;
	let current;

	btn = new Btn({
			props: {
				btn: "filled",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			div11 = element("div");
			div0 = element("div");
			h3 = element("h3");
			t0 = text("projects");
			t1 = space();
			p0 = element("p");
			t2 = text("projects forthcoming, for now here are some convenience links");
			t3 = space();
			div3 = element("div");
			a0 = element("a");
			div1 = element("div");
			t4 = text("dapi");
			t5 = space();
			a1 = element("a");
			div2 = element("div");
			t6 = text("dlog");
			t7 = space();
			p1 = element("p");
			t8 = text("(these aren't projects, just little sandboxes i'm playing with from time to time)");
			t9 = space();
			div6 = element("div");
			a2 = element("a");
			div4 = element("div");
			t10 = text("canvas");
			t11 = space();
			a3 = element("a");
			div5 = element("div");
			t12 = text("editor");
			t13 = space();
			div9 = element("div");
			a4 = element("a");
			div7 = element("div");
			t14 = text("github");
			t15 = space();
			a5 = element("a");
			div8 = element("div");
			t16 = text("dotfiles");
			t17 = space();
			div10 = element("div");
			p2 = element("p");
			t18 = text("Website currently under construction!");
			t19 = space();
			a6 = element("a");
			create_component(btn.$$.fragment);
			this.h();
		},
		l(nodes) {
			div11 = claim_element(nodes, "DIV", { "slot:title": true });
			var div11_nodes = children(div11);
			div0 = claim_element(div11_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			h3 = claim_element(div0_nodes, "H3", {});
			var h3_nodes = children(h3);
			t0 = claim_text(h3_nodes, "projects");
			h3_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t1 = claim_space(div11_nodes);
			p0 = claim_element(div11_nodes, "P", {});
			var p0_nodes = children(p0);
			t2 = claim_text(p0_nodes, "projects forthcoming, for now here are some convenience links");
			p0_nodes.forEach(detach);
			t3 = claim_space(div11_nodes);
			div3 = claim_element(div11_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			a0 = claim_element(div3_nodes, "A", { href: true, class: true });
			var a0_nodes = children(a0);
			div1 = claim_element(a0_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			t4 = claim_text(div1_nodes, "dapi");
			div1_nodes.forEach(detach);
			a0_nodes.forEach(detach);
			t5 = claim_space(div3_nodes);
			a1 = claim_element(div3_nodes, "A", { href: true, class: true });
			var a1_nodes = children(a1);
			div2 = claim_element(a1_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			t6 = claim_text(div2_nodes, "dlog");
			div2_nodes.forEach(detach);
			a1_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			t7 = claim_space(div11_nodes);
			p1 = claim_element(div11_nodes, "P", {});
			var p1_nodes = children(p1);
			t8 = claim_text(p1_nodes, "(these aren't projects, just little sandboxes i'm playing with from time to time)");
			p1_nodes.forEach(detach);
			t9 = claim_space(div11_nodes);
			div6 = claim_element(div11_nodes, "DIV", { class: true });
			var div6_nodes = children(div6);
			a2 = claim_element(div6_nodes, "A", { href: true, class: true });
			var a2_nodes = children(a2);
			div4 = claim_element(a2_nodes, "DIV", { class: true });
			var div4_nodes = children(div4);
			t10 = claim_text(div4_nodes, "canvas");
			div4_nodes.forEach(detach);
			a2_nodes.forEach(detach);
			t11 = claim_space(div6_nodes);
			a3 = claim_element(div6_nodes, "A", { href: true, class: true });
			var a3_nodes = children(a3);
			div5 = claim_element(a3_nodes, "DIV", { class: true });
			var div5_nodes = children(div5);
			t12 = claim_text(div5_nodes, "editor");
			div5_nodes.forEach(detach);
			a3_nodes.forEach(detach);
			div6_nodes.forEach(detach);
			t13 = claim_space(div11_nodes);
			div9 = claim_element(div11_nodes, "DIV", { class: true });
			var div9_nodes = children(div9);
			a4 = claim_element(div9_nodes, "A", { href: true, class: true });
			var a4_nodes = children(a4);
			div7 = claim_element(a4_nodes, "DIV", { class: true });
			var div7_nodes = children(div7);
			t14 = claim_text(div7_nodes, "github");
			div7_nodes.forEach(detach);
			a4_nodes.forEach(detach);
			t15 = claim_space(div9_nodes);
			a5 = claim_element(div9_nodes, "A", { href: true, class: true });
			var a5_nodes = children(a5);
			div8 = claim_element(a5_nodes, "DIV", { class: true });
			var div8_nodes = children(div8);
			t16 = claim_text(div8_nodes, "dotfiles");
			div8_nodes.forEach(detach);
			a5_nodes.forEach(detach);
			div9_nodes.forEach(detach);
			t17 = claim_space(div11_nodes);
			div10 = claim_element(div11_nodes, "DIV", { class: true });
			var div10_nodes = children(div10);
			p2 = claim_element(div10_nodes, "P", {});
			var p2_nodes = children(p2);
			t18 = claim_text(p2_nodes, "Website currently under construction!");
			p2_nodes.forEach(detach);
			t19 = claim_space(div10_nodes);
			a6 = claim_element(div10_nodes, "A", { href: true });
			var a6_nodes = children(a6);
			claim_component(btn.$$.fragment, a6_nodes);
			a6_nodes.forEach(detach);
			div10_nodes.forEach(detach);
			div11_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div0, "class", "content");
			attr(div1, "class", "col projects svelte-wq0mrd");
			attr(a0, "href", "https://github.com/clpi/dapi");
			attr(a0, "class", "projects svelte-wq0mrd");
			attr(div2, "class", "col projects svelte-wq0mrd");
			attr(a1, "href", "https://dlog.div.is");
			attr(a1, "class", "projects svelte-wq0mrd");
			attr(div3, "class", "row svelte-wq0mrd");
			attr(div4, "class", "col canvas svelte-wq0mrd");
			attr(a2, "href", "/canvas");
			attr(a2, "class", "canvas svelte-wq0mrd");
			attr(div5, "class", "col canvas svelte-wq0mrd");
			attr(a3, "href", "/canvas/editor");
			attr(a3, "class", "canvas svelte-wq0mrd");
			attr(div6, "class", "row svelte-wq0mrd");
			attr(div7, "class", "col canvas svelte-wq0mrd");
			attr(a4, "href", "https://github.com/clpi");
			attr(a4, "class", "canvas svelte-wq0mrd");
			attr(div8, "class", "col canvas svelte-wq0mrd");
			attr(a5, "href", "https://github.com/clpi/dotfiles");
			attr(a5, "class", "canvas svelte-wq0mrd");
			attr(div9, "class", "row svelte-wq0mrd");
			attr(a6, "href", "/contact");
			attr(div10, "class", "row svelte-wq0mrd");
			attr(div11, "slot:title", "content");
		},
		m(target, anchor) {
			insert(target, div11, anchor);
			append(div11, div0);
			append(div0, h3);
			append(h3, t0);
			append(div11, t1);
			append(div11, p0);
			append(p0, t2);
			append(div11, t3);
			append(div11, div3);
			append(div3, a0);
			append(a0, div1);
			append(div1, t4);
			append(div3, t5);
			append(div3, a1);
			append(a1, div2);
			append(div2, t6);
			append(div11, t7);
			append(div11, p1);
			append(p1, t8);
			append(div11, t9);
			append(div11, div6);
			append(div6, a2);
			append(a2, div4);
			append(div4, t10);
			append(div6, t11);
			append(div6, a3);
			append(a3, div5);
			append(div5, t12);
			append(div11, t13);
			append(div11, div9);
			append(div9, a4);
			append(a4, div7);
			append(div7, t14);
			append(div9, t15);
			append(div9, a5);
			append(a5, div8);
			append(div8, t16);
			append(div11, t17);
			append(div11, div10);
			append(div10, p2);
			append(p2, t18);
			append(div10, t19);
			append(div10, a6);
			mount_component(btn, a6, null);
			current = true;
		},
		p(ctx, dirty) {
			const btn_changes = {};

			if (dirty & /*$$scope*/ 1) {
				btn_changes.$$scope = { dirty, ctx };
			}

			btn.$set(btn_changes);
		},
		i(local) {
			if (current) return;
			transition_in(btn.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(btn.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div11);
			destroy_component(btn);
		}
	};
}

function create_fragment(ctx) {
	let t;
	let content;
	let current;

	content = new Content({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t = space();
			create_component(content.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-1o9run4\"]", document.head);
			head_nodes.forEach(detach);
			t = claim_space(nodes);
			claim_component(content.$$.fragment, nodes);
			this.h();
		},
		h() {
			document.title = "Projects • clp.is";
		},
		m(target, anchor) {
			insert(target, t, anchor);
			mount_component(content, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const content_changes = {};

			if (dirty & /*$$scope*/ 1) {
				content_changes.$$scope = { dirty, ctx };
			}

			content.$set(content_changes);
		},
		i(local) {
			if (current) return;
			transition_in(content.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(content.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t);
			destroy_component(content, detaching);
		}
	};
}

class Projects extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Projects;
//# sourceMappingURL=index.js.map
